import { render, staticRenderFns } from "./articulos_atributos.vue?vue&type=template&id=31482958&"
import script from "./articulos_atributos.vue?vue&type=script&lang=js&"
export * from "./articulos_atributos.vue?vue&type=script&lang=js&"
import style0 from "./articulos_atributos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports